<script>
    import { navigate } from "svelte-routing";
    import { loadProduce } from "../stores";

    export let slug;
    export let newprod;
    let prod = {
        slug: "",
        name: "",
        protein: 0,
        fat: 0,
        carbs: 0,
        baseAmount: 0,
        baseUnit: "",
    };

    async function save() {
        let method;
        let route;
        if (newprod) {
            method = "POST";
            route = "/api/produce";
        } else {
            method = "PUT";
            route = "/api/produce/" + prod.slug;
        }

        let response = await fetch(route, {
            method,
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(prod),
        });

        if (response.ok) {
            newprod = false;
            prod = await response.json();

            await loadProduce();
            navigate("/produce/" + prod.slug, { replace: false });
        } else {
            alert("Error");
        }
    }

    let promise;
    if (newprod) {
        promise = Promise.resolve();
    } else {
        promise = (async () => {
            let result = await fetch("/api/produce/" + slug);
            prod = await result.json();
        })();
    }
</script>

{#await promise then}
    <h1>{prod.name}</h1>

    <div class="with-sidebar">
        <label class="sidebar" for="name">Name</label>
        <input
            class="not-sidebar"
            id="name"
            type="text"
            bind:value={prod.name}
        />
    </div>

    <div class="with-sidebar">
        <label class="sidebar" for="protein">Protein per serving</label>
        <input
            class="not-sidebar"
            id="protein"
            type="number"
            bind:value={prod.protein}
        />
    </div>
    <div class="with-sidebar">
        <label class="sidebar" for="fat">Fat per serving</label>
        <input
            class="not-sidebar"
            id="fat"
            type="number"
            bind:value={prod.fat}
        />
    </div>
    <div class="with-sidebar">
        <label class="sidebar" for="carbs">Carbs per serving</label>
        <input
            class="not-sidebar"
            id="carbs"
            type="number"
            bind:value={prod.carbs}
        />
    </div>
    <div class="with-sidebar">
        <label class="sidebar" for="baseAmount">How much is a serving</label>
        <input
            class="not-sidebar"
            id="baseAmount"
            type="number"
            bind:value={prod.baseAmount}
        />
    </div>
    <div class="with-sidebar">
        <label class="sidebar" for="baseUnit"
            >Unit of how much a serving is</label
        >
        <input
            class="not-sidebar"
            id="baseUnit"
            type="text"
            bind:value={prod.baseUnit}
        />
    </div>
    <button on:click={save} class="fill">Save</button>
{/await}
